<template>
  <v-footer app height="auto">
    <v-layout justify-center row wrap>
      <v-flex grey py-3 text-xs-center white--text xs12>
        {{ user.nmusuario }} - <strong>{{ user.fantasia }}</strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>
<script>
export default {
  name: "Footer",
  props: {
    user: Object
  }
};
</script>
